module.exports = __webpack_public_path__ + "static/Mobile-Apps.9b259870.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/mobile-app/assets/Mobile-Apps.png
// module id = 278
// module chunks = 35783957827783